import React from "react";
import { Link, useNavigate } from "react-router-dom";

export default function Notifications(){
    const navigate = useNavigate();
    
    return (
		<div className="chatbox">
			<div className="chatbox-close"></div>
			<div className="custom-tab-1">
				<ul className="nav nav-tabs">
					<li className="nav-item">
						<a className="nav-link" data-bs-toggle="tab" href="#notes">Notifications</a>
					</li>
				</ul>
				<div className="tab-content">
					<div className="tab-pane fade active show" id="notes" role="tabpanel">
						<div className="card mb-sm-3 mb-md-0 note_card">
							<div className="card-body contacts_body p-0 dlab-scroll" id="DLAB_W_Contacts_Body2">
								<ul className="contacts mt-3">
									<li className="active">
										<div className="d-flex bd-highlight">
											<div className="user_info">
												<span>A new marketer Adams was created</span>
												<p>6th Jan 2025</p>
											</div>
										</div>
									</li>

									<li className="">
										<div className="d-flex bd-highlight">
											<div className="user_info">
												<span>A new marketer Chinny was created</span>
												<p>10th Jan 2025</p>
											</div>
										</div>
									</li>

									<li className="">
										<div className="d-flex bd-highlight">
											<div className="user_info">
												<span>N902 revenue was added to the account</span>
												<p>9th Jan 2025</p>
											</div>
										</div>
									</li>

									<li className="">
										<div className="d-flex bd-highlight">
											<div className="user_info">
												<span>You logged in 35 mins ago</span>
												<p>10th Jan 2025</p>
											</div>
										</div>
									</li>

									<li className="">
										<div className="d-flex bd-highlight">
											<div className="user_info">
												<span>5 users has subscribed</span>
												<p>3rd Jan 2025</p>
											</div>
										</div>
									</li>
									<li className="active">
										<div className="d-flex bd-highlight">
											<div className="user_info">
												<span>A new marketer Adams was created</span>
												<p>6th Jan 2025</p>
											</div>
										</div>
									</li>

									<li className="">
										<div className="d-flex bd-highlight">
											<div className="user_info">
												<span>A new marketer Chinny was created</span>
												<p>10th Jan 2025</p>
											</div>
										</div>
									</li>

									<li className="">
										<div className="d-flex bd-highlight">
											<div className="user_info">
												<span>N902 revenue was added to the account</span>
												<p>9th Jan 2025</p>
											</div>
										</div>
									</li>

									<li className="">
										<div className="d-flex bd-highlight">
											<div className="user_info">
												<span>You logged in 35 mins ago</span>
												<p>10th Jan 2025</p>
											</div>
										</div>
									</li>

									<li className="">
										<div className="d-flex bd-highlight">
											<div className="user_info">
												<span>5 users has subscribed</span>
												<p>3rd Jan 2025</p>
											</div>
										</div>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
    );
}